import authTokenResolver from "@/api/v2/auth-token-resolver";
import httpClient from "@/bundles/http-client";

class ApiClient
{
    #baseUrl;

    constructor(baseUrl = '/api/v2') {
        this.#baseUrl = baseUrl;
    }

    uri(path) {
        return this.#baseUrl + path;
    }

    #addToken(config, token) {
        if (typeof config === 'undefined') {
            config = {};
        }

        if (typeof config.headers === 'undefined') {
            config.headers = {};
        }

        config.headers['Authorization'] = 'Bearer ' + token;

        return config;
    }

    get(url, config) {
        return httpClient.getThrottled(url, config);
    }

    getAuthenticated(url, config) {
        return authTokenResolver.getToken().then((token) => {
            return this.get(url, this.#addToken(config, token));
        });
    }

    post(url, data, config) {
        return httpClient.postThrottled(url, data, config);
    }

    postCsrf(url, data, config) {
        return httpClient.postCsrf(url, data, config);
    }

    postAuthenticated(url, data, config) {
        return authTokenResolver.getToken().then((token) => {
            return this.post(url, data, this.#addToken(config, token));
        });
    }

    delete(url, config) {
        return httpClient.deleteThrottled(url, {}, config);
    }

    deleteCsrf(url, config) {
        return httpClient.deleteCsrf(url, config);
    }

    deleteAuthenticated(url, config) {
        return authTokenResolver.getToken().then((token) => {
            return this.delete(url, this.#addToken(config, token));
        });
    }

    put(url, data, config) {
        return httpClient.putThrottled(url, data, config);
    }

    putCsrf(url, data, config) {
        return httpClient.putCsrf(url, data, config);
    }

    putAuthenticated(url, data, config) {
        return authTokenResolver.getToken().then((token) => {
            return this.put(url, data, this.#addToken(config, token));
        });
    }
}

export default ApiClient;
